import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Breadcrumb } from './Breadcrumb';
import { Gallery } from './Gallery';
import { PurchaseCard } from './PurchaseCard';
import { Tabs } from './Tabs';
import { BackLink } from './BackLink';
/**
 * Gen3 E-Foot Gear product detail page.
 *
 * Every section owns its own state. The page orchestrator just composes
 * the sections — no props are passed in. Cross-section coordination
 * (e.g. PurchaseCard's "View sizing chart" flipping Tabs to the sizing
 * tab) is handled internally between the two section files via a
 * window CustomEvent.
 */
export function Gen3EFootGearPage() {
  return <div className="min-h-screen bg-white flex flex-col font-sans text-gray-900" data-id="element-416">
      <Header data-id="element-417" />

      <main className="flex-grow pt-32 pb-20 bg-gray-50" data-id="element-418">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-419">
          <Breadcrumb data-id="element-420" />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start" data-id="element-421">
            <Gallery data-id="element-422" />
            <PurchaseCard data-id="element-423" />
          </div>

          <Tabs data-id="element-424" />

          <BackLink data-id="element-425" />
        </div>
      </main>

      <Footer data-id="element-426" />
    </div>;
}